export class CompactListColumn {
    key: string;
    name: string;
    icon: string;
    sort: string;
    sortByKey?: string;
    sortNumeric: boolean = false;
    template: string;
    visible = true;
    width: number;
    tagColorKey: string;

    constructor(obj = null) {
        this.width = 20;
        if (obj) {
            Object.assign(this, obj);
        }
    }
}